import { track } from '@adsk/acs-web-analytics';

import { planTaskPluginMetadata } from '../consts';

export const trackPlanTaskEvent = (event: string, referenceType: string) =>
  track(event, {
    reference_type: referenceType,
    referencing_tool: planTaskPluginMetadata.type,
  });
